var React = require('react');

function CloseSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.29289 16.293C1.90237 16.6835 1.90237 17.3167 2.29289 17.7072C2.68342 18.0977 3.31658 18.0977 3.70711 17.7072L10 11.4143L16.2929 17.7072C16.6834 18.0977 17.3166 18.0977 17.7071 17.7072C18.0976 17.3167 18.0976 16.6835 17.7071 16.293L11.4142 10.0001L17.7071 3.7072C18.0976 3.31667 18.0976 2.68351 17.7071 2.29299C17.3166 1.90246 16.6834 1.90246 16.2929 2.29298L10 8.58588L3.70711 2.29298C3.31658 1.90246 2.68342 1.90246 2.29289 2.29298C1.90237 2.68351 1.90237 3.31667 2.29289 3.7072L8.58579 10.0001L2.29289 16.293Z","fill":"black"}));
}

CloseSmall.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = CloseSmall;

CloseSmall.default = CloseSmall;
